import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.PopupActions', {
    invalidConditions: 'Please ensure that all set conditions are valid',
    done: 'Done',
    xeroDataSyncButtonTitle: 'Pull values from Xero',
    netSuiteDataSyncButtonTitle: 'Pull values from Oracle NetSuite',
});
